import { menuItemClasses, outlinedInputClasses, paperClasses } from '@mui/material';

import { muiDisabled } from '../themes/base.theme';
import { resolveTypographyFromTheme } from '../tokens/font.helper';

const muiSelectOverride = {
  defaultProps: {
    MenuProps: {
      disablePortal: true,
      PaperProps: {
        elevation: 1,
      },
    },
  },
  styleOverrides: {
    icon: {
      marginTop: '-0.25rem',
      right: '1rem',

      [`&.MuiSelect-iconOpen`]: {
        transform: 'rotate(180deg)',
      },
    },
    select: ({ theme }) => ({
      ...resolveTypographyFromTheme(theme, 'components.input.base.typography', 'body'),
    }),
    root: ({ theme }) => ({
      paddingTop: 0,
      paddingBottom: 0,
      width: '100%',
      height: theme?.components?.input?.base?.height?.mobile,
      color: theme?.palette?.text?.input,
      backgroundColor: theme?.palette?.background?.input,
      border: theme?.components?.input?.base?.border?.size,
      borderColor: theme?.components?.input?.base?.border?.color,
      borderRadius: theme?.components?.input?.base?.border?.radius,
      outline: theme?.components?.input?.base?.outline?.size,
      outlineColor: theme?.components?.input?.base?.outline?.color,
      outlineOffset: theme?.components?.input?.base?.outline?.offset,
      transition: 'outline-color 0.15s ease-in-out, box-shadow 0.2s ease-in-out',

      [`& .${outlinedInputClasses.notchedOutline}`]: {
        border: 'none',
      },

      [`&:not(:disabled):hover`]: {
        ...(theme?.components?.input?.states?.hover || {}),
      },

      [`&:focus-within, &:focus-within:hover`]: {
        ...(theme?.components?.input?.states?.focus || {}),
        ...(theme?.components?.input?.states?.focusVisible || {}),
      },

      [`&.${muiDisabled} `]: {
        ...(theme?.components?.input?.states?.disabled || {}),
      },

      // select `options` styles
      [`& .${paperClasses.root}`]: {
        backgroundColor: theme?.palette?.background?.selectOption,

        [`&:not(:disabled):hover`]: {
          [`& .${menuItemClasses.root}`]: {
            color: theme?.components?.select?.base?.option?.color,
            backgroundColor: theme?.palette?.background?.selectOption,
          },
        },

        [`& .${menuItemClasses.root}`]: {
          padding: '1rem',
          ...resolveTypographyFromTheme(theme, 'components.input.base.typography', 'body'),
          color: theme?.components?.select?.base?.option?.color,
          transition: 'color 0.25s ease-in-out, background-color 0.25s ease-in-out',

          [`&:not(:disabled):hover`]: {
            color: theme?.palette?.text?.input,
            backgroundColor: theme?.components?.select?.base?.option?.backgroundColor?.hover,
          },

          [`&[aria-selected='true']`]: {
            color: theme?.palette?.text?.input,
            backgroundColor: theme?.components?.select?.base?.option?.backgroundColor?.selected,
          },
        },
      },
    }),
  },
  variants: [],
};

export default muiSelectOverride;
